/**
 * NovelSprig 品牌支付配置
 */
import type { BrandPaymentConfig } from '../types'
import { chapterCommonTexts, payCommonTexts, subscribeCommonTexts } from '../common'
import { colors as brandColors } from '@/config/brands'

export const novelsprigPaymentConfig: BrandPaymentConfig = {
  brand: 'novelsprig',

  // 充值页面配置
  pay: {
    theme: {},
    texts: payCommonTexts,
    resources: {
      goldCoinIcon: '/images/novelsprig/welfare-gold.png',
    },
  },

  // 订阅页面配置
  subscribe: {
    texts: subscribeCommonTexts,
    resources: {
      vipBg: '/images/novelsprig/vip_bg.svg',
      memberSubscribeBg: '/images/novelsprig/member_subscribe_bg.svg',
      vipIcon: '/images/novelsprig/reader-vip.svg',
      vipDiscountIcon: '/images/novelsprig/reader-vip.svg',
      discountBg: '/images/novelsprig/discount.avif',
      showVipIcon: true,
    },
    colors: {
      redGradient: 'linear-gradient(90deg, #FF9F43 0.03%, #FF7E5F 100%)',
      purpleTextGradient: 'linear-gradient(180deg, #FFDDC7 0%, #FFE4D1 50%, #FFEDD5 100%)',
      subscribeText1: brandColors!.primary,
      subscribeText2: brandColors!.text.primary,
      subscribeText3: brandColors!.text.secondary,
      subscribeText4: brandColors!.text.secondary,
    },
  },

  // 阅读器弹窗配置
  chapter: {
    themeDefaults: { background: '#F8FBF8', size: '38' },
    texts: chapterCommonTexts,
    colors: {
      coinsGradient: 'linear-gradient(180deg, #10B981, #ffffff)',
      coinsPopupText1: '#FFFFFF',
      coinsPopupText2: '#10B981',
      coinsPopupText3: '#4B5563',
      coinsPopupText4: '#FFFFFF',
      vipBg: '#D1FAE5',
      subscribeActiveBg: '#ECFDF5',
      purpleTextGradient: 'linear-gradient(180deg, #FFDDC7 0%, #FFE4D1 50%, #FFEDD5 100%)',
      pinkGradient: 'linear-gradient(90deg, #FF9F43 0.03%, #FF7E5F 100%)',
      memberSubscribeBg: '/images/novelsprig/chapter/member_subscribe_bg.svg',
      showVipIcon: true,
    },
  },
}
